import { TransactionTagsRepo } from '../ITransactionTagsRepo';
import { TransactionTag } from '../TransactionTag';
import unTagAll from './unTagAll';

const deleteTransactionTag = async (tagUUID: TransactionTag['uuid']) => {
	await unTagAll(tagUUID);
	return TransactionTagsRepo.delete(tagUUID);
}

export default deleteTransactionTag;